// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","593":"framework","834":"94726e6d"}[chunkId] || chunkId) + "-" + {"108":"df094b0fb69b6fc7d845","293":"0fb909ac9690a9392fe3","556":"0c5f2317b630cfa619d3","593":"ed2bdf76c7fdee1c0783","834":"ac0e80655ea58b3cf4ea"}[chunkId] + ".js";
};